import React from "react";
import {Col, Row, Table} from "react-bootstrap";
import HeaderWithHelp from "../SalesAnalysis/HeaderWithHelp.jsx";
import Farbfeld from "./Farbfeld.jsx";
import {formatDatum, formatFarbnummer, formatMenge} from "./format.js";

/**
 * "Unverzerrte Nachfrage aus dem B2B-Shop" (PLAN.md Abschnitt 4a.1b/F17):
 * Top-20-Suchbegriffe ohne Treffer (Suchmaschinen-Spam bereits vom Backend
 * herausgefiltert) und Top-20-Farbtöne in stehengebliebenen Warenkörben.
 * Leere Listen verschwinden vollständig (Hausregel).
 */
export default function UnverzerrteNachfrage({sucheOhneTreffer, warenkoerbeTop}) {
    const hatSuche = sucheOhneTreffer && sucheOhneTreffer.length > 0;
    const hatWarenkorb = warenkoerbeTop && warenkoerbeTop.length > 0;

    if (!hatSuche && !hatWarenkorb) {
        return null;
    }

    return (
        <Row className="g-3">
            {hatSuche && (
                <Col md={6}>
                    <HeaderWithHelp help="Suchbegriffe im B2B-Shop ohne einen einzigen Treffer – Nachfrage, die weder Bestellung noch Faktura wurde. Suchmaschinen-Spam (Muster „【…】“) ist bereits herausgefiltert.">
                        <h2 className="h6">Suchen ohne Treffer</h2>
                    </HeaderWithHelp>
                    <Table responsive size="sm">
                        <thead>
                            <tr>
                                <th>
                                    <HeaderWithHelp help="Wonach im B2B-Shop gesucht wurde.">Suchbegriff</HeaderWithHelp>
                                </th>
                                <th className="text-end">
                                    <HeaderWithHelp help="Wie oft dieser Suchbegriff ohne Treffer gesucht wurde.">Häufigkeit</HeaderWithHelp>
                                </th>
                                <th>
                                    <HeaderWithHelp help="Letzter Suchzeitpunkt.">Zuletzt</HeaderWithHelp>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {sucheOhneTreffer.map((s) => (
                                <tr key={s.suchbegriff}>
                                    <td>{s.suchbegriff}</td>
                                    <td className="text-end">{formatMenge(s.haeufigkeit)}</td>
                                    <td className="small text-muted">{formatDatum(s.zuletzt_am) || "–"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Col>
            )}

            {hatWarenkorb && (
                <Col md={6}>
                    <HeaderWithHelp help="Farbtöne, die seit mindestens drei Tagen unverändert in einem B2B-Warenkorb liegen, ohne bestellt worden zu sein.">
                        <h2 className="h6">Stehengebliebene Warenkörbe</h2>
                    </HeaderWithHelp>
                    <Table responsive size="sm">
                        <thead>
                            <tr>
                                <th>
                                    <HeaderWithHelp help="Farbnummer und Bezeichnung des Farbtons.">Farbton</HeaderWithHelp>
                                </th>
                                <th>
                                    <HeaderWithHelp help="Interne Artikelnummer.">Artikelnr.</HeaderWithHelp>
                                </th>
                                <th className="text-end">
                                    <HeaderWithHelp help="Summe der Menge in stehengebliebenen Warenkörben.">Stück</HeaderWithHelp>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {warenkoerbeTop.map((w) => (
                                <tr key={w.artikel_nummer}>
                                    <td>
                                        <div className="d-flex align-items-center gap-2">
                                            <Farbfeld farbwert={null} size={14} />
                                            {w.farbnummer !== null && w.farbnummer !== undefined ? `${formatFarbnummer(w.farbnummer)} ` : ""}
                                            {w.farbname || "–"}
                                        </div>
                                    </td>
                                    <td className="small text-muted">{w.artikel_nummer}</td>
                                    <td className="text-end">{formatMenge(w.menge_summe)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Col>
            )}
        </Row>
    );
}
